module.exports = __webpack_public_path__ + "static/media/zl_2_6.59256f30.png";